const endpoint = "https://uvpb.cuba-lv.com"
const cpoint = "https://central-backend.cuba-lv.com"

const startpoint = `${cpoint}/`
const mediapoint = `https://s3-media.cuba-lv.com/`

const gamePlace = { studio: "tbilisi", room: "po6-room" } // tbilisi, bishkek

export { endpoint, mediapoint, startpoint, gamePlace }
